const BASE_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vT0fNjU1ZtpFQ7iVGT2GBgOpKKQZuLo3nrw3LKlGfSB4V7MBKGHhLEKHux3z_CcYIVdE9tIRdKk9nmn/";

const BASE_URL_1 =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ5aBxTbpaSokX_dhMf6EJ8DX3JQIPt_ahudsML1O48Db04MWnBweYOzKJcQ1rPpyAOjL2SIEpVp7vR/";

const BASE_URL_2 =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vQI0kemlIR5dtBiuf22CxQsk0RGBqrJQ5E4lLOq0ArIV0x1vjrtA090c9672j8sVvGMdby_cnN95A6U/";

const BASE_URL_3 =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vTX5JI-wvs2qpzZkk7P0lvDD4zHtrwfx-7bkV0FbXPEoxlwqKN7gMNeUFwWXfYOemJaroTUC1mKTabQ/";

const BASE_URL_4 =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vROF0PD0IB3UGphnpXyh-j1Szq1qp1aH_4lcsUNrA9fO__eXCa0uR5oiZbSNQJV-VNnSL7uYSUBMZAL/";

const BASE_URL_5 =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vQoPQITwX9HXOqZnGF47vf9FKzsqW0pjPfdUEQ1fIQcNQKkhOnPKT1tAKWeLcbR2FpcezzCW3og_iRu/";

export const HOME_STEPS_1_URL =
  BASE_URL + "pub?gid=726133424&single=true&output=tsv";

export const HOME_STEPS_2_URL =
  BASE_URL + "pub?gid=1249133589&single=true&output=tsv";

export const HOME_PAGE_URL =
  BASE_URL + "pub?gid=160890447&single=true&output=tsv";

export const HOME_STAKEHOLDERS_URL =
  BASE_URL + "pub?gid=2051192446&single=true&output=tsv";

export const HOME_RISKS_URL =
  BASE_URL + "pub?gid=667528679&single=true&output=tsv";

export const HOME_AREAS_URL =
  BASE_URL + "pub?gid=1181354921&single=true&output=tsv";

export const AREA_1_INTRO_URL =
  BASE_URL_1 + "pub?gid=1150713918&single=true&output=tsv";

export const AREA_1_PROJECTS_URL =
  BASE_URL_1 + "pub?gid=1793295650&single=true&output=tsv";

export const AREA_1_LINES_URL =
  BASE_URL_1 + "pub?gid=143849359&single=true&output=tsv";

export const AREA_1_LINES_NAME_URL =
  BASE_URL_1 + "pub?gid=1642148075&single=true&output=tsv";

export const AREA_1_VIZ_1_URL =
  BASE_URL_1 + "pub?gid=1601132570&single=true&output=tsv";

export const AREA_1_VIZ_2_URL =
  BASE_URL_1 + "pub?gid=1523344048&single=true&output=tsv";

export const AREA_1_CONCLUSIONS_URL =
  BASE_URL_1 + "pub?gid=1371130749&single=true&output=tsv";

export const AREA_2_INTRO_URL =
  BASE_URL_2 + "pub?gid=1150713918&single=true&output=tsv";

export const AREA_2_PROJECTS_URL =
  BASE_URL_2 + "pub?gid=1793295650&single=true&output=tsv";

export const AREA_2_LINES_URL =
  BASE_URL_2 + "pub?gid=143849359&single=true&output=tsv";

export const AREA_2_LINES_NAME_URL =
  BASE_URL_2 + "pub?gid=1718722544&single=true&output=tsv";

export const AREA_2_VIZ_1_URL =
  BASE_URL_2 + "pub?gid=1601132570&single=true&output=tsv";

export const AREA_2_VIZ_2_URL =
  BASE_URL_2 + "pub?gid=1523344048&single=true&output=tsv";

export const AREA_2_CONCLUSIONS_URL =
  BASE_URL_2 + "pub?gid=1371130749&single=true&output=tsv";

export const AREA_3_INTRO_URL =
  BASE_URL_3 + "pub?gid=1150713918&single=true&output=tsv";

export const AREA_3_PROJECTS_URL =
  BASE_URL_3 + "pub?gid=1793295650&single=true&output=tsv";

export const AREA_3_LINES_URL =
  BASE_URL_3 + "pub?gid=143849359&single=true&output=tsv";

export const AREA_3_LINES_NAME_URL =
  BASE_URL_3 + "pub?gid=121399020&single=true&output=tsv";

export const AREA_3_VIZ_1_URL =
  BASE_URL_3 + "pub?gid=1601132570&single=true&output=tsv";

export const AREA_3_VIZ_2_URL =
  BASE_URL_3 + "pub?gid=1523344048&single=true&output=tsv";

export const AREA_3_CONCLUSIONS_URL =
  BASE_URL_3 + "pub?gid=1371130749&single=true&output=tsv";

export const AREA_4_INTRO_URL =
  BASE_URL_4 + "pub?gid=1150713918&single=true&output=tsv";

export const AREA_4_PROJECTS_URL =
  BASE_URL_4 + "pub?gid=1793295650&single=true&output=tsv";

export const AREA_4_LINES_URL =
  BASE_URL_4 + "pub?gid=143849359&single=true&output=tsv";

export const AREA_4_LINES_NAME_URL =
  BASE_URL_4 + "pub?gid=201011532&single=true&output=tsv";

export const AREA_4_VIZ_1_URL =
  BASE_URL_4 + "pub?gid=1601132570&single=true&output=tsv";

export const AREA_4_VIZ_2_URL =
  BASE_URL_4 + "pub?gid=1523344048&single=true&output=tsv";

export const AREA_4_CONCLUSIONS_URL =
  BASE_URL_4 + "pub?gid=1371130749&single=true&output=tsv";

export const AREA_5_INTRO_URL =
  BASE_URL_5 + "pub?gid=1150713918&single=true&output=tsv";

export const AREA_5_PROJECTS_URL =
  BASE_URL_5 + "pub?gid=1793295650&single=true&output=tsv";

export const AREA_5_LINES_URL =
  BASE_URL_5 + "pub?gid=143849359&single=true&output=tsv";

export const AREA_5_LINES_NAME_URL =
  BASE_URL_5 + "pub?gid=1230439759&single=true&output=tsv";

export const AREA_5_VIZ_1_URL =
  BASE_URL_5 + "pub?gid=1601132570&single=true&output=tsv";

export const AREA_5_VIZ_2_URL =
  BASE_URL_5 + "pub?gid=1523344048&single=true&output=tsv";

export const AREA_5_CONCLUSIONS_URL =
  BASE_URL_5 + "pub?gid=1371130749&single=true&output=tsv";

export const LINES_VALUES = {
  L: 0,
  M: 1,
  H: 2,
  VH: 3,
};
